<template>
  <div class="floatMsg-container">
    <a-carousel
      :dots="false"
      :autoplay="autoplay"
      dot-position="right"
      ref="carouselRef"
      :key="carouselKey"
      style="width: 100%"
    >
      <div
        class="floatMsgContent"
        v-show="show"
        v-for="(message, messageIndex) in messageList"
        :key="messageIndex"
      >
        <auth-img v-if="[1, 39].includes(ctxBusinessType)" class="notice" :src="notice" alt="" />
        <div class="count" v-if="show">
          {{ `${messageIndex + 1}/${messageList?.length}条` }}
        </div>
        <div
          v-if="[22, 23, 24, 25, 26, 27].includes(ctxBusinessType)"
          v-show="!message?.quickDealNavigationOtherRemark"
          :class="['float-status', targetWorkOrder.operationName ? 'float-status-deal' : '']"
        >
          {{ targetWorkOrder.operationName ? '已处理' : '待处理' }}
        </div>
        <div class="float-content">
          <div class="float-msg">
            <!-- 文案部分 -->
            <a-popover
              :overlayStyle="{ width: '500px' }"
              overlayClassName="floatMsg-popover"
              placement="topLeft"
            >
              <template #content>
                <span style="color: #fff">
                  {{ handleFloatText(message) }}
                </span>
              </template>
              <div class="float-text">
                {{ handleFloatText(message) }}
              </div>
            </a-popover>
            <!-- 按钮链接 -->
            <div v-if="[27].includes(ctxBusinessType)" class="float-action">
              <div class="float-link">
                <div style="margin-left: 10px">复诊预约单:</div>
                <div
                  v-for="(item, index) in [ctxBusinessId]"
                  @click="emitFloatAction(ctxBusinessType, item)"
                  class="link"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div
              @click="emitFloatAction(ctxBusinessType, ctxBusinessId)"
              v-else-if="ctxBusinessType === 24"
            >
              <span class="link">查看患者修改后的预约单>></span>
            </div>
            <div
              v-else-if="hasCheck(message)"
              @click="emitFloatAction(ctxBusinessType, ctxBusinessId)"
              class="link-botton"
            >
              <span class="link">去查看>></span>
            </div>
          </div>
          <div v-if="targetWorkOrder.operationName" class="dealHistory">
            {{ targetWorkOrder.operationTime }} 健管-{{ targetWorkOrder.operationName }}已处理
          </div>
          <div
            class="change"
            v-if="show && messageList?.length > 1"
            @click="() => handleChange(messageIndex === 0 ? 1 : -1)"
          >
            {{ `${messageIndex === 0 ? '下' : '上'}一条` }}
          </div>
        </div>
      </div>
    </a-carousel>
  </div>
</template>

<script setup>
// 22 复诊跟踪工单
// 23 待添加复诊日期工单
// 24 医生/患者需修改
// 25 医生/患者未确认复诊日期
// 26 补充诊疗记录
// 27 有效扫码工单
// 39 患者私聊工单
// 5 代购工单 （包含ai小结）
import Config from '@/config/index'
import { defineProps, defineEmits, computed, watch, ref } from 'vue'
import notice from '@/assets/img/notice.png'

const props = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const messageList = ref([])

const autoplay = ref(true) // 是否自动切换
const carouselRef = ref(null)
const carouselKey = ref(0)

const targetWorkOrder = computed(() => props.workOrderGroupInfo.targetWorkOrder)

watch(
  () => targetWorkOrder.value,
  val => {
    messageList.value = [targetWorkOrder.value]
    // 如果有备注新增一条
    if (val?.quickDealNavigationOtherRemark || val?.quickDealNavigationBusinessFollowRemark) {
      messageList.value.push({
        ...targetWorkOrder.value,
        quickDealNavigationBusinessFollowRemark: null
      })
    }
    // 1- 无效的私聊（没有ID，没有备注）
    // 39 -兼容需求跟踪
    const Index = messageList.value.findIndex(
      f =>
        [1, 39].includes(f.businessType) &&
        !f.quickDealNavigationBusinessId &&
        !f.quickDealNavigationOtherRemark &&
        !f.quickDealNavigationBusinessFollowRemark
    )
    if (Index > -1) {
      messageList.value.splice(Index, 1)
    }
    carouselKey.value++
  },
  { immediate: true, deep: true }
)

// 24、25需区分主体是患者还是医生，其它为固定文案
const handleFloatText = msg => {
  const businessType = msg.businessType
  let text = Config.FLOAT_WORK_ORDER[businessType]
  switch (businessType) {
    case 24:
      text = msg.quickDealNavigationOtherRemark
      break
    case 39:
      text = msg.quickDealNavigationBusinessFollowRemark
      break
    case 1:
      text = msg.quickDealNavigationBusinessFollowRemark || text
      break
  }
  return text
}
// 去查看是否显示
const hasCheck = computed(() => {
  return msg => {
    const Checks = Object.keys(Config.FLOAT_WORK_ORDER)
    const hasCheck = Checks.some(v => ~~v === msg.businessType)
    // 私聊关怀不需要操作
    if (msg.businessType === 1 && msg.quickDealNavigationBusinessFollowRemark) {
      return false
    }
    // 需求跟踪工单类型 判断是否有小结id
    if (msg.businessType === 39 && msg.quickDealNavigationBusinessId === null) {
      return false
    }
    return hasCheck
  }
})

const emit = defineEmits(['floatActionByType'])
const ctxBusinessId = computed(
  () => props.workOrderGroupInfo.targetWorkOrder.quickDealNavigationBusinessId
)
const ctxBusinessType = computed(() => props.workOrderGroupInfo.targetWorkOrder.businessType)
const emitFloatAction = (workOrderType, args = '') => {
  const Checks = Object.keys(Config.FLOAT_WORK_ORDER)
  const isAi = Checks.some(v => ~~v === workOrderType)
  emit('floatActionByType', isAi, workOrderType, args)
}

const show = computed(() => {
  // 13 是完成, 67是失效 不需要展示
  const ST = props.workOrderGroupInfo.targetWorkOrder.stateTag
  const hasOver = [1, 3, 6, 7].includes(ST)
  return !hasOver
})

// 切换消息上下条
const handleChange = go => {
  autoplay.value = false
  if (go === 1) carouselRef.value?.next()
  else carouselRef.value?.prev()
}
</script>

<style lang="scss" scoped>
.floatMsg-container {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0 16px;
  .notice {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .ant-carousel .slick-slider .slick-track {
    height: 100% !important;
  }
}
.floatMsgContent {
  width: 100%;
  height: 100%;
  display: flex !important;
  // justify-content: space-between;
  align-items: center;
  // padding: 0 16px;

  .float-status {
    border: 1px solid #fb992e;
    border-radius: 4px;
    font-weight: 500;
    font-size: 12px;
    color: #fb992e;
    padding: 0px 6px;
    margin-right: 8px;
    min-width: 50px;
  }
  .float-status-deal {
    border: 1px solid #24bca2;
    color: #24bca2;
  }
  .float-content {
    font-size: 14px;
    height: 47px;
    color: #333333;
    font-weight: 500;
    min-width: 70%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .float-msg {
      display: flex;
      min-width: 40%;

      .float-text {
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        white-space: nowrap;
        align-items: center;
        width: fit-content;
      }

      .float-action {
        flex: 1;
        white-space: nowrap;
      }

      .float-link {
        display: flex;
      }
    }
    .link-botton {
      flex-shrink: 0;
      width: 70px;
      .link {
        cursor: pointer;
        color: #1890ff;
        margin: 0 4px;
        min-width: 80px;
      }
    }
    .dealHistory {
      font-weight: 400;
      color: #666;
      font-size: 14px;
    }
  }

  .count {
    min-width: 44px;
    height: 20px;
    border: 1px solid #fb992e;
    border-radius: 4px;
    font-weight: 500;
    font-size: 12px;
    color: #fb992e;
    text-align: center;
    margin-right: 8px;
    white-space: nowrap;
  }

  .change {
    cursor: pointer;
    color: #1890ff;
    margin: 0 4px;
    width: 10%;
    text-align: right;
    white-space: nowrap;
  }

  .text {
    min-width: 15%;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
